import { createSlice } from '@reduxjs/toolkit';

const name = 'labelsManage';

const initialState = {
  data: [],
  loaded: false,
  loading: false,
  error: null,
};

const labelsManage = createSlice({
  name,
  initialState,
  reducers: {
    getLabelsRequest: (state) => {
      state.loading = true;
      state.loaded = false;
      state.payout = null;
    },
    getLabelsSuccess: (state, { payload }) => {
      state.data = payload.labels;
      state.loading = false;
      state.loaded = true;
    },
    getLabelsFailure: (state, { payload }) => {
      state.loading = false;
      state.loaded = true;
      state.error = payload.error;
    },
  },
});

export const { actions } = labelsManage;

export default labelsManage.reducer;
